

export const attendanceConstants = {

    REMOVE_ATTENDANCE : 'REMOVE_ATTENDANCE',
    SHOW_COURSE_ATTENDANCE: 'SHOW_COURSE_ATTENDANCE',
    LOAD_ATTENDANCE_TYPES: 'LOAD_ATTENDANCE_TYPES',
    ADD_ATTENDANCE: 'ADD_ATTENDANCE',
    LOAD_ATTENDANCE_STATUS: 'LOAD_ATTENDANCE_STATUS',
    ADD_ATTENDANCE_STATUS: 'ADD_ATTENDANCE_STATUS',
    LOAD_HOLIDAYS: 'LOAD_HOLIDAYS'
};